import { parseInline } from '@wds/astro-bot-shared/course/inline';

/**
 * Lesson text with `**bold**` (the only markup of course texts) as React nodes: bold spans become `<strong>`,
 * everything else is a plain text node (React escapes it). No wrapper element, so it sits inside any `<p>`, `<h3>`
 * or `<button>`. Use it for lesson content only — never for what a learner wrote or a model answered.
 */
export function InlineText({ text }: { text: string }): JSX.Element {
  return (
    <>
      {parseInline(text).map((seg, i) => (seg.bold ? <strong key={i}>{seg.text}</strong> : seg.text))}
    </>
  );
}
